import { DEVEXTREME_LICENSE_KEY } from "@bds/devextreme-license";
export const DevExtremeLicenseProvider = {
    provide: DEVEXTREME_LICENSE_KEY,
    useValue: 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImEzNDg5ZWM0LTVmZTgtNDgwOS1hZWYxLWMyYzkwNjNkNWU3YiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.JNXynVaRBwU5f3HVxC12bLU9PvxRmJ15zdSua0gP0Oe3OVnLtiZ/Wfv1+WT1dWONxMm9vu0Dk2k9Lr/kM11QsTtwHmnqFmxGlB8nURxTJ5EJp2A1XhzpWQVriXhcB4rebmQU/g=='
};
